import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { AuthProvider, buildMsalConfig } from "@optimgov/module-auth"
import { App } from "./App"
import "./styles/globals.css"
import "./i18n"

const rc = (window as any).__CONTRACTACIO_CONFIG__

const msalConfig = buildMsalConfig({
	clientId: rc?.msalClientId ?? import.meta.env.VITE_ENTRA_CLIENT_ID,
	tenantId: rc?.msalTenantId ?? import.meta.env.VITE_ENTRA_TENANT_ID,
	hubUrl: rc?.hubUrl ?? import.meta.env.VITE_HUB_URL ?? "https://app.optimgov.es",
	apiScopes: [rc?.apiScope ?? import.meta.env.VITE_API_SCOPE ?? `api://${rc?.msalClientId ?? import.meta.env.VITE_ENTRA_CLIENT_ID}/access`],
	authority: rc?.msalAuthority ?? import.meta.env.VITE_AUTHORITY,
	knownAuthorities: (rc?.msalKnownAuthorities ?? import.meta.env.VITE_KNOWN_AUTHORITIES)?.split(","),
	redirectUri: rc?.msalRedirectUri,
})

const authMode = (rc?.authMode ?? ((import.meta.env.VITE_LOCAL_MODE === "true" || import.meta.env.VITE_AUTH_MODE === "mock")
	? "mock"
	: "msal")) as "mock" | "msal"

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<AuthProvider mode={authMode} context="module" msalConfig={msalConfig}>
			<App />
		</AuthProvider>
	</StrictMode>,
)
